import React, { useEffect, useState, useMemo } from "react";
import SocialIcons from "@/components/SocialIcons";
import { Link } from "react-router-dom";
const Footer = ({ desktop, mobile }) => {
	const [dateTime, setDateTime] = useState(new Date());
	const currentYear = useMemo(() => dateTime.getFullYear(), [dateTime]);

	const sections = [
		{
			title: "INDEX",
			link: "/",
			links: [
				{ text: "Products", to: "/products" },
				{ text: "Marketplaces", to: "/marketplaces" },
				{ text: "Trends", to: "/trends" },
				{ text: "Success Stories", to: "/success-stories" },
				{ text: "Blog", to: "/blog" },
			],
		},
		{
			title: "TERMS OF USE",
			link: "/terms-of-use",
			links: [
				{ text: "Notice of Privacy", to: "/privacy" },
				{ text: "Dropshipping", to: "/dropshipping" },
				{ text: "Terms and Conditions", to: "/terms" },
			],
		},
		{
			title: "FAQ",
			link: "/faq",
			links: [
				{ text: "How to use Rbetrage?", to: "/how-to-use" },
				{
					text: "What is the most trending product?",
					to: "/trending-products",
				},
				{ text: "How can I get support?", to: "/support" },
			],
		},
	];

	return (
		<>
			{/**Desktop Footer */}
			<div
				className={`w-full bg-[#193D34] flex flex-col items-center justify-center absolute ${desktop} hidden lg:flex`}
			>
				{/* Centered Container */}
				<div className="w-full max-w-[1360px] px-4 flex flex-col items-center py-8">
					{/* Top Section */}
					<div className="w-full flex justify-between items-start  exact-1024:pr-6">
						{/* Logo and Description */}
						<div className="flex flex-col gap-[16px]">
							<img
								loading="lazy"
								decoding="async"
								src="/assets/home/footer/footerLogo.svg"
								alt="Footer Logo"
								className="w-[209.33px] h-[32px]"
							/>
							<div className="w-[217px] text-[#F1F6E9] font-montserrat font-light text-[8px] leading-[12px] tracking-[3%]">
								Rbetrage is an AI-Powered Dropshipping automation software that
								helps discover trending products and secure the most lucrative
								deals for your online store from top suppliers. Our intuitive
								tools streamline your workflow, maximize your profit and save
								hours of time. Revolutionize your dropshipping process with
								powerful automation.
							</div>
						</div>

						{/* Section Links */}
						{sections.map((section, index) => (
							<div key={index} className="w-[150px] flex flex-col gap-[18px]">
								<div className="text-footerColor font-montserrat font-semibold text-[13px]">
									<Link key={index} to={section.link}>
										{section.title}
									</Link>
								</div>
								<div className="flex flex-col space-y-2 text-white font-montserrat font-medium text-[13px] whitespace-nowrap exact-1024:text-[11px]">
									{section.links.map((link, i) => (
										<Link key={i} to={link.to}>
											{link.text}
										</Link>
									))}
								</div>
							</div>
						))}

						{/* Join Us and Subscribe */}
						<div className="w-ful max-w-[182px] flex flex-col gap-[16px] exact-1024:pl-8">
							{/* Join Us */}
							<div className="flex flex-col gap-[8px]">
								<div className="text-footerColor font-montserrat font-semibold text-[13px]">
									JOIN US
								</div>
								<div className="flex space-x-[8px]">
									<SocialIcons />
								</div>
							</div>

							{/* Subscribe */}
							<div className="w-full max-w-[272px] h-[32px] flex">
								<input
									type="text"
									placeholder="Email"
									className="w-full h-full px-2 text-footerColor font-montserrat font-medium text-[13px] border border-footerColor"
								/>
								<button className="w-[91.62px] h-[32px] bg-[#B7D974] text-[#193D34] font-montserrat font-medium text-[13px] rounded-tr-lg rounded-br-lg flex items-center justify-center">
									Subscribe
								</button>
							</div>
						</div>
					</div>

					{/* Divider */}
					<div className="w-full border border-footerColor my-8"></div>

					{/* Copyright */}
					<div className="w-full text-footerColor font-montserrat font-medium text-[10px] leading-[100%]">
						© Ai Tech Solutions Limited {currentYear}. All Rights Reserved.
					</div>
				</div>
			</div>

			{/**Mobile Version Footer */}

			<div
				className={`absolute w-full h-[700px] bg-[#193D34] flex flex-col items-center p-[40px] gap-[20px] ${mobile ? mobile : ""} lg:hidden`}
			>
				{/* Logo */}
				<div className="w-[209.33px] h-[32px]">
					<img
						loading="lazy"
						decoding="async"
						src="/assets/home/footer/footerLogo.svg"
						alt="Footer Logo"
						className="w-full h-full"
					/>
				</div>

				{/* Description */}
				<div className="w-[314px] h-[78px] text-[#F1F6E9] font-montserrat font-light text-[10px] leading-[13px] tracking-[3%] text-center">
					Rbetraj is an AI-Powered Dropshipping automation software that helps
					discover trending products and secure the most lucrative deals for
					your online store from top suppliers. Our intuitive tools streamline
					your workflow, maximize your profit and save hours of time.
					Revolutionize your dropshipping process with powerful automation.
				</div>

				{/* Index & Terms */}
				<div className="w-[314px] h-[264px] flex flex-col gap-[32px]">
					<div className="w-[150px] h-[116px] flex flex-col gap-[16px]">
						<div className="text-footerColor font-montserrat font-semibold text-[13px]">
							<Link to="/terms">TERMS OF USE</Link>
						</div>
						<div className="w-[150px] h-[82px] text-white font-montserrat font-medium text-[13px] font-[Montserrat]">
							<Link to="/privacy">
								<p>Notice Of Privacy</p>
							</Link>
							<br />
							<Link to="/dropshipping">
								<p>Dropshipping</p>
							</Link>
							<br />
							<Link to="/terms">
								<p>Terms and Conditions</p>
							</Link>
							<br />
						</div>
					</div>
					<div className="w-[217px] h-[106px] flex flex-col gap-[16px]">
						<div className="text-footerColor font-montserrat font-semibold text-[13px]">
							<Link to="/faq">FAQ</Link>
						</div>
						<div className="w-[217px] h-[106px] text-white font-montserrat font-medium text-[13px] font-[Montserrat]">
							<Link to="/how-to-use">
								<p>How to use Rbetraj?</p>
							</Link>
							<br />
							<Link to="/trending-products">
								<p className="whitespace-nowrap">
									What is most trending product?
								</p>
							</Link>
							<br />
							<Link to="/support">
								<p>How can I get support?</p>
							</Link>
						</div>
					</div>
				</div>

				{/* Social Icons */}
				<div className="w-[314px] h-[60px] pb-[16px] flex flex-col items-start gap-[8px] mt-8">
					<div className="flex space-x-[8px]">
						<div className="text-footerColor font-montserrat font-semibold text-[13px]">
							JOIN US
						</div>
						<SocialIcons />
					</div>
				</div>

				{/* Subscribe Input */}

				<div className="w-[314px] h-[32px] flex border border-footerColor rounded-lg overflow-hidden">
					<input
						type="text"
						placeholder="Email"
						className="w-full h-full px-2 text-footerColor placeholder-footerColor font-montserrat font-medium text-[13px] bg-transparent border-none outline-none rounded-tl-lg rounded-bl-lg"
					/>
					<button className="w-[106px] bg-[#B7D974] text-[#193D34] font-montserrat font-medium text-[13px] flex items-center justify-center rounded-tr-lg rounded-br-lg">
						Subscribe
					</button>
				</div>

				{/* Copyright */}
				<div className="w-[314px] h-[54px] pt-[16px] flex flex-col items-center gap-[16px] text-footerColor font-montserrat font-medium text-[10px] leading-[100%] text-center">
					<div className="w-[314px] border border-footerColor"></div>© Ai Tech
					Solutions Limited {currentYear}. All Rights Reserved.
				</div>
			</div>
		</>
	);
};

export default Footer;
